<template>
<v-layout wrap justify-center text-center>
    
    <v-flex>
        <v-container>
        <video ref="video" height="800px" autoplay >
        <source :src ="video" type="video/mp4">
        </video>
        </v-container>
    </v-flex>
    
</v-layout>
</template>
<script>
export default {
    
    data(){
        return{
            video:require("../../assets/video/kurmaTutorial.mp4")
        }
    },
    computed:
    {
        videoElement () {
      return this.$refs.video;
    }, 
    
    }
}
</script>